const en = {
  qualified: {
    title: 'Thank you for completing this study!',
    body1: 'You are free to close down the browser window.',
    body2: 'We hope to see you again soon.',
    refCode: 'Ref Code: {code}',
  },
  quotaFull: {
    title: 'This study is closed',
    body1: 'Thank you for your interest in our study.',
    body2: 'Unfortunately we have already received all the responses we need.',
    body3: 'We hope to see you in one of our future studies!',
    refCode: 'Ref Code: {code}',
  },
  terminated: {
    title: 'Thank you for sharing your feedback!',
    body1:
      'We hope to see you soon in our future studies. Until then, we wish you a great day.',
    body2: 'Please close down this browser window.',
    refCode: 'Ref Code: {code}',
  },
  mismatch: {
    title: 'Thank you for your interest',
    body1: 'Unfortunately, you are not in the target group for this specific study.',
    body2: 'You can close this page.',
    code: 'Code: {code}',
  },
  error: {
    title: 'We are not able to serve your request',
    linkProblemDetailed:
      'The link you have followed is having problems. Please check that the link in the address line matches the one given to you and try again.',
    linkProblemGeneric:
      'The link you have followed is having problems. Please try again.',
    contactPerson:
      'If the problem persist, please let the person you got the link from, know about this is issue.',
    errorCode: 'Error Code: {code}',
  },
};

export type FeedbackMessages = typeof en;
export default en;
